import { object } from 'common/helpers'


export const initialState = {
  paymentData: null,
  carouselProducts: {
    fragrances: [],
    skincare: [],
    makeup: [],
    wellness: [],
  },
}

export const setCarouselProducts = (state, payload) => (
  object.set(state, 'carouselProducts', payload)
)

export const setPaymentData = (state, payload) => (
  object.set(state, 'paymentData', payload)
)

export const resetPaymentData = (state) => (
  object.set(state, 'paymentData', null)
)
